module.exports = __webpack_public_path__ + "media/packs/images/flags/AT-f81f4833a7e6aec73a54af8eff88accb.svg";